import { Params, QueryParamsHandling, IsActiveMatchOptions } from "@angular/router";
import { FuseNavigationItem } from "./interface/navigation.types";

export class NavigationItem implements FuseNavigationItem {
    id?: string;
    title?: string;
    subtitle?: string;
    type!: "aside" | "basic" | "collapsable" | "divider" | "group" | "spacer";
    hidden?: ((item: FuseNavigationItem) => boolean);
    active?: boolean;
    disabled?: boolean;
    tooltip?: string;
    link?: string;
    fragment: string = "";
    preserveFragment?: boolean;
    queryParams?: Params | null;
    queryParamsHandling?: QueryParamsHandling | null;
    externalLink?: boolean;
    target?: string;
    exactMatch?: boolean;
    isActiveMatchOptions?: IsActiveMatchOptions;
    function?: ((item: FuseNavigationItem) => void);
    classes?: { title?: string; subtitle?: string; icon?: string; wrapper?: string; };
    icon?: string;
    badge?: {
        title?: string;
        classes?: string;
    };
    children?: FuseNavigationItem[];
    meta?: any;
}
